import { _window } from './window.utils';

export function willRedirect(loginUrl: URL) {
  const currentURL = new URL(_window().location.href);

  const isLocalhost = currentURL.hostname === 'localhost';
  if (!isLocalhost && currentURL.hostname.startsWith('dev-')) {
    loginUrl.host = 'dev-' + loginUrl.host;
  }
  const hasSameHostname =
    currentURL.hostname === loginUrl.hostname || isLocalhost;

  const isCodementumLoginPage =
    hasSameHostname && currentURL.pathname.includes('/login');
  const isCodementumRegisterPage =
    hasSameHostname && currentURL.pathname.includes('/register');
  const isCodementumOAuth2RedirectPage =
    hasSameHostname && currentURL.pathname.includes('/oauth2/redirect');
  const isCodementumPricingPage =
    hasSameHostname && currentURL.pathname.includes('/pricing');
  const isCodementumGiftPricingPage =
    hasSameHostname && currentURL.pathname.includes('/gift-pricing');

  const redirect =
    !isCodementumPricingPage &&
    !isCodementumLoginPage &&
    !isCodementumOAuth2RedirectPage &&
    !isCodementumRegisterPage &&
    !isCodementumGiftPricingPage;

  if (redirect) {
    loginUrl.searchParams.set('redirect', currentURL.toString());
  }

  if (isLocalhost) {
    loginUrl.host = 'localhost:8080';
    loginUrl.protocol = 'http:';
  }

  return {
    redirect,
    url: loginUrl
  };
}
